import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()({
  headline: {
    fontWeight: 600,
    marginBottom: 40,
  },
  callout: {
    marginBottom: 60,
    '&:last-child': {
      marginBottom: 0,
    },
  },
  h3: {
    fontWeight: 600,
  },
});
